import { ReminderSendingType } from "../reminders/reminder.enum";

export class ReminderSettingModel {
  sendAutomatically: boolean;
  sendingType: ReminderSendingType;
  scheduleDaysBeforeDeadline: number[];
  reminderTime: string | null;

  constructor(data: Partial<ReminderSettingModel> = {}) {
    this.sendAutomatically = data.sendAutomatically ?? false;
    this.sendingType = data.sendingType ?? ReminderSendingType.Email;
    this.scheduleDaysBeforeDeadline = data.scheduleDaysBeforeDeadline ?? [];
    this.reminderTime = data.reminderTime ?? null;
  }
}
